import { render, staticRenderFns } from "./EscalationList.vue?vue&type=template&id=7acc87b7&scoped=true&"
import script from "./EscalationList.vue?vue&type=script&lang=ts&"
export * from "./EscalationList.vue?vue&type=script&lang=ts&"
import style0 from "./EscalationList.vue?vue&type=style&index=0&id=7acc87b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc87b7",
  null
  
)

export default component.exports